import React, { useEffect, useState } from "react";
import "./Cateloging.scss";
import { DataGrid } from "@mui/x-data-grid";
import { FaShareAlt } from "react-icons/fa";
import {
  AvatarGroup,
  Box,
  Button,
  CircularProgress,
  Drawer,
  IconButton,
  Modal,
  Typography,
} from "@mui/material";
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  EmailShareButton,
  EmailIcon,
} from "react-share";
import { useNavigate } from "react-router-dom";
import { CommonAPImain } from "../../../../Utils/API/CommonAPImain/CommonAPImain";
import { IoMdClose, IoMdShareAlt } from "react-icons/io";
import CustomTextField from "../../../TextFiled/Index";
import { homeLoading } from "../../../Recoil/atom";
import { useRecoilState } from "recoil";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  bgcolor: "background.paper",
  border: "none",
  outline: "none",
  boxShadow: 24,
  p: 4,
};

const checkImageAvailability = (url) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = url;
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
  });
};

const Cateloging = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isLoading, setIsLoading] = useRecoilState(homeLoading);
  const [reportSaleData, setReportSaleData] = useState(false);
  const [imageAvailability, setImageAvailability] = useState({});
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isSticky, setIsSticky] = useState(false);
  const navigate = useNavigate();

  const [open, setOpen] = React.useState(false);
  const handleOpen = (data) => {
    sessionStorage.setItem("catelogAlbumMasterID", data?.AlbumMasterid);
    sessionStorage.setItem(
      "catelogAlbumMasterName",
      JSON.stringify(data?.albumName)
    );
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 115) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const storedCatelogList = sessionStorage.getItem("mainCatelogList");
    if (storedCatelogList) {
      const parsedData = JSON.parse(storedCatelogList);
      setReportSaleData(parsedData);
      setFilteredData(parsedData);
      parsedData.forEach((item) => {
        checkImageAvailability(item.ImageToDisplay || item.DefImage).then(
          (isAvailable) => {
            setImageAvailability((prevState) => ({
              ...prevState,
              [item.AlbumMasterid]: isAvailable
                ? item.ImageToDisplay
                : item.DefImage,
            }));
          }
        );
      });
    }
    // else {
    //   setIsLoading(true);
    //   CommonAPImain("Catelog_List")
    //     .then((response) => {
    //       if (response?.Data?.DT && Array.isArray(response?.Data?.DT)) {
    //         const updatedData = response?.Data?.DT.map((item) => ({
    //           ...item,
    //           ImageToDisplay: item.AlbumImagePath || item.DefImage,
    //         }));
    //         setReportSaleData(updatedData);
    //         setFilteredData(updatedData);
    //         sessionStorage.setItem(
    //           "mainCatelogList",
    //           JSON.stringify(updatedData)
    //         );
    //         updatedData.forEach((item) => {
    //           checkImageAvailability(item.ImageToDisplay).then(
    //             (isAvailable) => {
    //               setImageAvailability((prevState) => ({
    //                 ...prevState,
    //                 [item.AlbumMasterid]: isAvailable
    //                   ? item.ImageToDisplay
    //                   : item.DefImage,
    //               }));
    //             }
    //           );
    //         });
    //       } else {
    //         setReportSaleData([]);
    //         setFilteredData([]);
    //       }
    //       setIsLoading(false);
    //     })
    //     .catch((err) => {
    //       console.error(err);
    //       setReportSaleData([]);
    //       setFilteredData([]);
    //       setIsLoading(false);
    //     });
    // }
  }, []);

  const handleSearch = (event) => {
    const query = event.target.value;
    setSearchQuery(query);

    if (query) {
      const filtered = reportSaleData.filter((item) =>
        item.albumName.toLowerCase().includes(query.toLowerCase())
      );
      setFilteredData(filtered);
    } else {
      setFilteredData(reportSaleData);
    }
  };

  const clearSearch = () => {
    setSearchQuery("");
    setFilteredData(reportSaleData);
  };

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const shareUrl = "https://www.example.com";

  const handleNavigate = (data) => {
    sessionStorage.setItem("catelogAlbumMasterID", data?.AlbumMasterid);
    navigate("/CatelogingDetail");
  };

  return (
    <div className="cataloging_container">
      {isLoading && (
        <div className="loader-overlay">
          <CircularProgress className="loadingBarManage" />
        </div>
      )}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <p className="choose_textModel">Choose the share option</p>
          <div className="share_option_main_div">
            <Button
              className="Option_share_catelog"
              onClick={() => navigate("/CatelogingShare")}
            >
              Existing Customer
            </Button>
            <Button
              className="Option_share_catelog"
              onClick={() => navigate("/NewCustomer")}
            >
              New Customer
            </Button>
          </div>
        </Box>
      </Modal>
      {!isLoading && (
        <div>
          <div className={`catelog_searchbar ${isSticky ? "sticky" : ""}`}>
            <CustomTextField
              value={searchQuery}
              borderoutlinedColor={"black"}
              onChange={handleSearch}
              placeholder="Search .."
              InputProps={{
                endAdornment: searchQuery && (
                  <IconButton onClick={clearSearch}>
                    <IoMdClose className="catelog_searchClose_icone" />
                  </IconButton>
                ),
              }}
              className="Catelog_SearchBox"
            />
          </div>

          <div className="catelog_detail_main__div">
            {Array.isArray(reportSaleData) &&
              filteredData.map((data, index) => {
                const imageSrc =
                  imageAvailability[data.AlbumMasterid] || data.DefImage;
                return (
                  <Button
                    key={index}
                    className="catelog_deatil_div"
                    onClick={() => handleNavigate(data)}
                  >
                    <div className="cateloging_sub_div">
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <img
                          key={index}
                          src={imageSrc}
                          className="catelog_show_img"
                        />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                        }}
                      >
                        <p className="catelog_Title_name">{data?.albumName}</p>
                        <p className="ctelog_itemCount">
                          {data?.DesignCnt} Items
                        </p>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <Button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleOpen(data);
                            }}
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <IoMdShareAlt
                              style={{
                                height: "25px",
                                width: "25px",
                              }}
                              className="cateloging_share_icone"
                            />
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Button>
                );
              })}
          </div>
        </div>
      )}
      <Drawer
        anchor="bottom"
        open={drawerOpen}
        onClose={toggleDrawer}
        className="drawer-container"
      >
        <div className="drawer-content">
          <div
            style={{
              padding: "20px",
              display: "flex",
              justifyContent: "space-around",
            }}
          >
            <FacebookShareButton url={shareUrl}>
              <FacebookIcon size={32} round />
            </FacebookShareButton>
            <TwitterShareButton url={shareUrl}>
              <TwitterIcon size={32} round />
            </TwitterShareButton>
            <WhatsappShareButton url={shareUrl}>
              <WhatsappIcon size={32} round />
            </WhatsappShareButton>
            <EmailShareButton url={shareUrl}>
              <EmailIcon size={32} round />
            </EmailShareButton>
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default Cateloging;

// import React, { useEffect, useState } from "react";
// import "./Cateloging.scss";
// import { DataGrid } from "@mui/x-data-grid";
// import { FaShareAlt } from "react-icons/fa";
// import {
//   AvatarGroup,
//   Box,
//   Button,
//   CircularProgress,
//   Drawer,
//   Modal,
//   Typography,
// } from "@mui/material";
// import {
//   FacebookShareButton,
//   TwitterShareButton,
//   WhatsappShareButton,
//   FacebookIcon,
//   TwitterIcon,
//   WhatsappIcon,
//   EmailShareButton,
//   EmailIcon,
// } from "react-share";
// import { useNavigate } from "react-router-dom";
// import { CommonAPImain } from "../../../../Utils/API/CommonAPImain/CommonAPImain";
// import { IoMdShareAlt } from "react-icons/io";

// const style = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: "80%",
//   bgcolor: "background.paper",
//   border: "none",
//   outline: "none",
//   boxShadow: 24,
//   p: 4,
// };

// const checkImageAvailability = (url) => {
//   return new Promise((resolve) => {
//     const img = new Image();
//     img.src = url;
//     img.onload = () => resolve(true);
//     img.onerror = () => resolve(false);
//   });
// };

// const Cateloging = () => {
//   const [drawerOpen, setDrawerOpen] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [reportSaleData, setReportSaleData] = useState(false);
//   const [imageAvailability, setImageAvailability] = useState({});
//   const navigate = useNavigate();

//   const [open, setOpen] = React.useState(false);
//   const handleOpen = (data) => {
//     sessionStorage.setItem("catelogAlbumMasterID", data?.AlbumMasterid);
//     sessionStorage.setItem("catelogAlbumMasterName", JSON.stringify(data?.albumName));
//     setOpen(true);
//   };
//   const handleClose = () => setOpen(false);

//   useEffect(() => {
//     setIsLoading(true);
//     CommonAPImain("Catelog_List")
//       .then((response) => {
//         if (response?.Data?.DT && Array.isArray(response?.Data?.DT)) {
//           setReportSaleData(response?.Data?.DT);
//           response?.Data?.DT.forEach((item) => {
//             if (item.AlbumImagePath) {
//               checkImageAvailability(item.AlbumImagePath).then(
//                 (isAvailable) => {
//                   setImageAvailability((prevState) => ({
//                     ...prevState,
//                     [item.id]: isAvailable,
//                   }));
//                 }
//               );
//             }
//           });
//         } else {
//           setReportSaleData([]);
//         }
//         setIsLoading(false);
//       })
//       .catch((err) => {
//         console.error(err);
//         setReportSaleData([]);
//         setIsLoading(false);
//       });
//   }, []);

//   const toggleDrawer = () => {
//     setDrawerOpen(!drawerOpen);
//   };

//   const shareUrl = "https://www.example.com";

//   const handleNavigate = (data) => {
//     sessionStorage.setItem("catelogAlbumMasterID", data?.AlbumMasterid);
//     navigate("/CatelogingDetail");
//   };

//   return (
//     <div className="cataloging_container">
//       {isLoading && (
//         <div className="loader-overlay">
//           <CircularProgress className="loadingBarManage" />
//         </div>
//       )}
//       <Modal
//         open={open}
//         onClose={handleClose}
//         aria-labelledby="modal-modal-title"
//         aria-describedby="modal-modal-description"
//       >
//         <Box sx={style}>
//           <p className="choose_textModel">Choose the share option</p>
//           <div className="share_option_main_div">
//             <Button
//               className="Option_share_catelog"
//               onClick={() => navigate("/CatelogingShare")}
//             >
//               Existing Customer
//             </Button>
//             <Button
//               className="Option_share_catelog"
//               onClick={() => navigate("/NewCustomer")}
//             >
//               New Customer
//             </Button>
//           </div>
//         </Box>
//       </Modal>

//       <div className="catelog_detail_main__div">
//         {Array.isArray(reportSaleData) &&
//           reportSaleData.map((data, index) => {
//             const imageAvailable = imageAvailability[data.id];
//             return (
//               <Button
//                 key={index}
//                 className="catelog_deatil_div"
//                 onClick={() => handleNavigate(data)}
//               >
//                 <div className="cateloging_sub_div">
//                   <div
//                     style={{ display: "flex", justifyContent: "space-between" }}
//                   >
//                     <div>
//                       <p className="catelog_Title_name">{data?.albumName}</p>
//                     </div>
//                     <div style={{ display: "flex", alignItems: "center" }}>
//                       {imageAvailable && (
//                         <img
//                           key={index}
//                           src={data?.AlbumImagePath}
//                           className="catelog_show_img"
//                         />
//                       )}
//                     </div>
//                   </div>
//                   <div className="catelog_item_div">
//                     <p className="ctelog_itemCount">{data?.DesignCnt} Items</p>
//                     <div>
//                       <Button
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           handleOpen(data);
//                         }}
//                       >
//                         <IoMdShareAlt
//                           style={{
//                             color: "#00a2e1",
//                             height: "25px",
//                             width: "25px",
//                           }}
//                         />
//                       </Button>
//                     </div>
//                   </div>
//                 </div>
//               </Button>
//             );
//           })}
//       </div>
//       <Drawer
//         anchor="bottom"
//         open={drawerOpen}
//         onClose={toggleDrawer}
//         className="drawer-container"
//       >
//         <div className="drawer-content">
//           <div
//             style={{
//               padding: "20px",
//               display: "flex",
//               justifyContent: "space-around",
//             }}
//           >
//             <FacebookShareButton url={shareUrl}>
//               <FacebookIcon size={32} round />
//             </FacebookShareButton>
//             <TwitterShareButton url={shareUrl}>
//               <TwitterIcon size={32} round />
//             </TwitterShareButton>
//             <WhatsappShareButton url={shareUrl}>
//               <WhatsappIcon size={32} round />
//             </WhatsappShareButton>
//             <EmailShareButton url={shareUrl}>
//               <EmailIcon size={32} round />
//             </EmailShareButton>
//           </div>
//         </div>
//       </Drawer>
//     </div>
//   );
// };

// export default Cateloging;
